import { setTheme } from "theme/default/setTheme";

export const setBackgroundColor_a0b9d2 = setTheme(({ theme }) => `background-color: ${theme.colors.color_a0b9d2}`);
